export enum ACTIVITIES_SORTS {
  CREATED_AT = "created_at",
}

export enum ACTIVITIES_FILTERS {
  CREATED_AT = "created_at",
}
